import api from "@/lib/api";

const YT_HOSTS = ["youtube.com", "www.youtube.com", "m.youtube.com", "music.youtube.com", "youtube-nocookie.com", "www.youtube-nocookie.com"];

export function parseYouTube(url) {
  if (!url) return null;
  let u;
  try { u = new URL(url.trim()); } catch (e) { return null; }
  const host = u.hostname.toLowerCase();
  const parts = u.pathname.split("/").filter(Boolean);
  let id = null, isShort = false;
  if (host === "youtu.be" || host === "www.youtu.be") id = parts[0];
  else if (YT_HOSTS.includes(host)) {
    if (parts[0] === "watch") id = u.searchParams.get("v");
    else if (parts.length >= 2 && ["shorts", "embed", "live", "v"].includes(parts[0])) { id = parts[1]; isShort = parts[0] === "shorts"; }
  }
  return id && /^[A-Za-z0-9_-]{11}$/.test(id) ? { id, isShort } : null;
}

export function toEmbedUrl(url) {
  if (!url) return null;
  const yt = parseYouTube(url);
  if (yt) return `https://www.youtube.com/embed/${yt.id}`;
  try {
    if (url.includes("youtube.com") || url.includes("youtu.be")) return null;
    if (url.includes("vimeo.com")) {
      const id = url.split("vimeo.com/")[1]?.split(/[?&/]/)[0];
      return id ? `https://player.vimeo.com/video/${id}` : url;
    }
  } catch (e) {}
  return url;
}

export function isVideoKind(kind) {
  return ["youtube", "vimeo", "video_file"].includes(kind);
}

const _blobCache = new Map(); // path -> persistent object URL (thumbnails)

export async function fetchBlobUrl(path) {
  const res = await api.get(path, { responseType: "blob" });
  return URL.createObjectURL(res.data);
}

// Cached variant for thumbnails: once fetched, the object URL is reused for the
// whole SPA session so scrolling/navigation never re-downloads the same image.
export async function fetchCachedBlobUrl(path) {
  if (_blobCache.has(path)) return _blobCache.get(path);
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  _blobCache.set(path, url);
  return url;
}

export async function downloadFile(id, filename) {
  try {
    const res = await api.get(`/resources/${id}/download`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (e) {
    let detail = "Download unavailable";
    try {
      const txt = await e.response?.data?.text?.();
      if (txt) detail = JSON.parse(txt).detail || detail;
    } catch (_) {}
    const err = new Error(detail);
    err.detail = detail;
    throw err;
  }
}

export async function registerExternal(id) {
  const { data } = await api.get(`/resources/${id}/download`);
  return data.external_url;
}
